import { render, staticRenderFns } from "./Itservices.vue?vue&type=template&id=13bfaeac&scoped=true&"
import script from "./Itservices.vue?vue&type=script&lang=js&"
export * from "./Itservices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfaeac",
  null
  
)

export default component.exports